<template>
  <Row class="row main">
    <i-col class="filter">
      <i
        v-if="showAdd"
        class="fas fa-plus-circle icon"
        @click="openAddItemWindow"
      />

      <i
        v-if="showRefresh"
        class="fas fa-sync-alt icon"
        @click="refreshAll"
      />

      <Badge
        v-if="showFilter"
        :dot="isFiltered"
        class="badge"
      >
        <Dropdown
          trigger="click"
          placement="bottom-end"
          class="dropdown"
        >
          <div
            class="selected"
            :class="{ 'active': isFiltered }"
          >
            <i class="fas fa-filter icon" />
            <i class="fas fa-angle-down" />
          </div>
          <DropdownMenu
            slot="list"
            class="elements"
          >
            <slot name="body" />
            <div class="row btn-section">
              <Button
                :disabled="!isFiltered"
                class="btn-reset"
                @click="resetFilters"
              >
                Reset Filters
                <i class="fas fa-trash icon" />
              </Button>
            </div>
          </DropdownMenu>
        </Dropdown>
      </Badge>

      <i
        v-if="showReset"
        class="fas fa-eraser icon"
        @click="resetData"
      />
    </i-col>
  </Row>
</template>

<script>
export default {
  props: {
    showAdd: {
      type: Boolean,
      default: false
    },
    showRefresh: {
      type: Boolean,
      default: false
    },
    showFilter: {
      type: Boolean,
      default: false
    },
    showReset: {
      type: Boolean,
      default: false
    },
    isFiltered: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    /**
     * Notifies the parent the Add Item button has been triggered.
     */
    openAddItemWindow () {
      this.$emit('onAddItem')
    },

    /**
     * Notifies the parent the Add Item button has been triggered.
     */
    refreshAll () {
      this.$emit('onRefreshAll')
    },

    /**
     * Notifies the parent it should remove any filter from the results.
     */
    resetFilters () {
      this.$emit('onResetFilters')
    },

    /**
     * Notifies the parent it should reset the panel's content.
     */
    resetData () {
      this.$emit('onResetData')
    }
  }
}
</script>

<style scoped>
  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
    user-select: none;
  }

  .row.main {
    position: sticky;
    top: 64px;
    z-index: 900;
  }

  .badge,
  .icon {
    margin-right: 8px;
  }

  .icon {
    width: 16px;
    font-size: 16px;
    cursor: pointer;
  }

  .icon.small {
    width: 12px;
    height: 12px;
    font-size: 12px;
    display: flex;
  }

  .icon:last-child {
    margin-right: 0;
  }

  .selected .icon {
    margin-right: 4px;
  }

  .capitalize {
    text-transform: capitalize;
  }

  .element-row.action {
    cursor: pointer;
  }

  .filter {
    margin: 0;
    padding: 0 8px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }

  .filter >>> .ivu-tooltip {
    margin-left: 8px;
  }

  .filter >>> .ivu-tooltip:first-child {
    margin-left: 0;
  }

  .filter .badge {
    height: 16px;
  }

  .filter >>> .ivu-badge-dot {
    right: 8px;
  }

  .filter .dropdown {
    /* margin-left: 8px; */
    width: 32px;
  }

  .filter .dropdown .selected {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: var(--color-black);
  }

  .filter .dropdown .options {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .filter .dropdown .options p {
    margin: 0 8px;
    width: 56px;
  }

  .filter .dropdown .options .icon.small {
    display: flex;
  }

  .filter .dropdown >>> .ivu-select-dropdown {
    width: auto;
  }

  .filter .dropdown .elements {
    padding: 0 8px;
    width: 240px;
  }

  .filter .dropdown .elements .row {
    margin: 0;
    padding: 4px 0;
  }

  .filter .dropdown .elements .row:nth-child(even) {
    padding-bottom: 8px;
  }

  .filter .dropdown .elements .row.btn-section {
    margin-top: 8px;
    padding: 0;
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  .filter .dropdown .elements .row.btn-section .btn-reset {
    font-weight: bold;
    color: var(--color-white);
    border-color: var(--color-gray-border);
    background-color: var(--color-green);
  }

  .filter .dropdown .elements .row.btn-section .btn-reset:disabled {
    color: var(--color-mid-gray);
    border-color: var(--color-light-gray);
    background-color: var(--color-border);
  }

  .filter .dropdown .elements .row.btn-section .btn-reset .icon {
    margin-left: 8px;
  }

  .filter .dropdown .elements .row p,
  .filter .dropdown .elements .row .element-row,
  .filter .dropdown .elements .row .element-row p {
    margin: 0;
    padding: 0 8px;
    width: 100%;
  }

  .filter .dropdown .elements .row .element-row {
    padding: 0;
    display: flex;
    flex-direction: row;
  }

  .filter .dropdown .elements .row .element-row p {
    margin: 0;
  }

  .right {
    display: flex;
    justify-content: flex-end;
  }

  .filter .dropdown .elements .row .element-row .icon {
    margin: 0;
    width: 16px;
  }

  .filter .dropdown .elements .row .select-input {
    width: 100%;
  }

  .filter .dropdown .elements .row .select-input.left >>> .ivu-select-selection {
    width: 100%;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .filter .dropdown .elements .row .select-input.right >>> .ivu-select-selection {
    width: 100%;
    border-left: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .filter .dropdown .elements .row .select-input.big-list >>> .ivu-select-dropdown {
    transform-origin: center top !important;
    top: unset !important;
    max-height: 400px;
    overflow-y: scroll;
  }

  .filter .dropdown .elements .row .select-input >>> .ivu-select-not-found {
    color: var(--color-red-alert);
    font-size: 12px;
    list-style: none;
    text-align: left;
    padding: 7px 16px;
  }

  .filter .dropdown .elements .dropdown-left {
    margin: 0;
    padding: 4px 0;
  }

  .filter .dropdown .elements .dropdown-left >>> .ivu-select-dropdown {
    margin-right: 8px;
  }

  .filter .dropdown .elements .row .buttons-row {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .filter .dropdown .elements .row .buttons-row p {
    width: calc(100% - 88px);
    margin-right: 8px;
  }

  .filter .radio-btn {
    padding: 0 8px;
    width: 40px;
    text-align: center;
    color: var(--color-black);
    border-color: var(--color-border);
  }

  .filter .radio-btn.ivu-radio-wrapper:after,
  .filter .radio-btn.ivu-radio-wrapper:before {
    content: none;
  }

  .filter .radio-btn.ivu-radio-wrapper-checked {
    background-color: var(--color-green-light);
    box-shadow: -1px 0 0 0 var(--color-border), 0 0 0 2px transparent;
    transition: none;
  }

  .search-box >>> .ivu-input.ivu-input-large {
    padding-right: 32px;
  }

  .search-box >>> .ivu-input-icon {
    right: 36px;
  }

  .search-box >>> .ivu-input-group-append {
    padding: 6px 8px;
    width: 36px;
  }

  .search-box >>> .ivu-input-group-append .ivu-btn {
    padding: 0;
    font-size: 16px;
    width: 16px;
    border: none;
  }
</style>
